import React, { useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DeleteModal from "../../ui/DeleteModal";
import PublishIcon from "@material-ui/icons/Publish";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import {
  publishCountry,
  updateCutOffTime,
  loadCentralWarehouses,
  setSelectedWarehouse,
  loadCountries,
  loadWhCountryMappings,
} from "../../../store/country/countryActions";
import { useSelector } from "react-redux";
import logo from "../../../assets/header-color.svg";
import ChangeLogs from "./ChangeLogs";

import DateFnsUtils from "@date-io/date-fns";
import { getHours, getMinutes, setMinutes, setHours } from "date-fns";
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    fontSize: 16,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.grey[100],
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  root: {
    maxWidth: 345,
  },
  media: {
    height: 110,
  },
});

export default function CountryListTable(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { centralWarehouses, selectedWarehouse, whCountriesMappings } = useSelector((state) => state.country);
  const [state, setState] = React.useState({
    publishAction: false,
    selectedItem: null,
    openChangeLogs: false,
  });

  useEffect(() => {
    dispatch(loadCentralWarehouses());
    dispatch(loadCountries());
    dispatch(loadWhCountryMappings());
  }, [dispatch]);

  // Set default warehouse value after warehouses are loaded
  useEffect(() => {
    if (centralWarehouses?.length > 0 && !selectedWarehouse) {
      // Check localStorage first
      const storedWarehouse = localStorage.getItem("warehouse");
      // Verify the stored warehouse still exists in the current list
      const isStoredWarehouseValid = storedWarehouse && 
        centralWarehouses.some(wh => wh.warehouse_id === storedWarehouse);
      
      if (isStoredWarehouseValid) {
        dispatch(setSelectedWarehouse(storedWarehouse));
      } else {
        // Set first warehouse as default if no valid stored warehouse
        dispatch(setSelectedWarehouse("110"));
        localStorage.setItem("warehouse", "110");
      }
    }
  }, [centralWarehouses, selectedWarehouse, dispatch]);

  const handleWarehouseChange = (event) => {
    dispatch(setSelectedWarehouse(event.target.value, selectedWarehouse));
    localStorage.setItem("warehouse", event.target.value);
  };

  const publishAction = (event) => {
    event.stopPropagation();
    setState({
      ...state,
      publishAction: true,
    });
  };

  const openChangeLogs = () => {
    setState({
      ...state,
      openChangeLogs: true,
    });
  };

  const closeModal = (name) => {
    setState({ ...state, [name]: false });
  };

  const publishActionConfirmation = () => {
    dispatch(publishCountry());
    closeModal("publishAction");
  };
  const modalPopUp = () => {
    if (state.publishAction) {
      return (
        <DeleteModal
          open={state.publishAction}
          close={() => closeModal("publishAction")}
          publishConfirmation={publishActionConfirmation}
        />
      );
    } else if (state.openChangeLogs) {
      return (
        <ChangeLogs
          open={state.openChangeLogs}
          close={() => closeModal("openChangeLogs")}
          changeLogs={props.changeLogs}
        />
      );
    }
  };

  const handleTimeChange = async (time, data) => {
    const hours = getHours(time);
    const minutes = getMinutes(time);
    const t = `${hours}:${minutes}`;
    dispatch(await updateCutOffTime(t, data?.title, "time"));
  };

  const handleHolidayChange = async (event, data) => {
    dispatch(await updateCutOffTime(event.target.value, data?.title, "day"));
  };

  const handleSwitchChange = async (e, data) => {
    if (!e.target.checked) {
      dispatch(await updateCutOffTime("", data?.title, "disable"));
    } else {
      dispatch(await updateCutOffTime("00:00", data?.title, "time"));
    }
  };

  const formatDateTime = (time) => {
    const timeArr = time ? time.split(":") : "00:00";
    return setHours(
      setMinutes(new Date(), Number(timeArr[1])),
      Number(timeArr[0])
    );
  };

  const weekdays_names = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const checkChecked = (val) => {
    return val ? true : false;
  };

  const getDays = (weekdays_names, selectedDay) => {
    const days = [];
    weekdays_names.forEach((day, i) => {
      if (selectedDay.indexOf(i.toString()) > -1) {
        days.push(day);
      }
    });
    return days;
  };

  const tabledoby = () => {
    if (props.tabaledata) {
      return props.tabaledata
      .filter(data => (whCountriesMappings.get(selectedWarehouse) || []).includes(data.name_en))
      ?.map((data) => (
        <StyledTableRow key={data.title} hover>
          {props?.tableheader?.map((cell, index) => {
           
            if (cell.type === "day") {
              const selected_day = data[cell.key]
                ? data[cell.key].split(",")
                : [];
              return (
                <TableCell>
                  <Select
                    multiple
                    value={selected_day}
                    renderValue={(selectedDay) => {
                      const days = getDays(weekdays_names, selectedDay);
                      return days.join(", ");
                    }}
                    onChange={(val) => handleHolidayChange(val, data)}
                  >
                    {weekdays_names?.map((v, idx) => {
                      return (
                        <MenuItem
                          key={weekdays_names.indexOf(v).toString()}
                          value={weekdays_names.indexOf(v).toString()}
                        >
                          <Checkbox
                            checked={selected_day.indexOf(idx.toString()) >= 0}
                          />
                          <ListItemText primary={v} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </TableCell>
              );
            } else if (cell.type === "timer") {
              const selectedDate = formatDateTime(data[cell.key]);
              return (
                <TableCell>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      value={selectedDate}
                      onChange={(val) => handleTimeChange(val, data)}
                      KeyboardButtonProps={{
                        "aria-label": "change time",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </TableCell>
              );
            } else if (cell.type === "switch") {
              let idChecked = checkChecked(data["cut_off_time"]);
              return (
                <TableCell>
                  <Switch
                    checked={idChecked}
                    onChange={(e) => handleSwitchChange(e, data)}
                    value="checkedB"
                    color="primary"
                  />
                </TableCell>
              );
            } else
              return (
                <TableCell
                  align="left"
                  key={index}
                  onClick={() => props.rowSelected(data)}
                  style={{ cursor: 'pointer' }}
                >
                  {data[cell.key]}
                </TableCell>
              );
          })}
        </StyledTableRow>
      ));
    } else {
      <div>No data found</div>;
    }
  };

  return (
    <Container maxWidth="xl">
        
      <Grid container spacing={2} style={{ margin: '16px 0' }}>
        <Grid item xs={12} md={4}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="warehouse-select-label">Central Warehouse</InputLabel>
            <Select
              labelId="warehouse-select-label"
              id="warehouse-select"
              value={selectedWarehouse}
              onChange={handleWarehouseChange}
              label="Central Warehouse"
            >
              <MenuItem value="">
                <em>Select a warehouse</em>
              </MenuItem>
              {centralWarehouses?.map((warehouse) => (
                <MenuItem key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                  {warehouse.warehouse_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Typography variant="subtitle2" gutterBottom align="left">
        Country List
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xm={1}>
          <TableContainer component={Paper}>
            <Table
              stickyHeader
              className={classes.table}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {props?.tableheader?.map((row) => (
                    <StyledTableCell align="left" key={row.name}>
                      {row.name}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>{tabledoby()}</TableBody>
            </Table>
          </TableContainer>
          {modalPopUp()}
        </Grid>
        <Grid item xm={1}>
          <Card className={classes.root}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={logo}
                title="Changes Log"
              />
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                  align="left"
                >
                  {props.hasChanges
                    ? "You have few changes pending to be published."
                    : "You don't have any changes yet."}
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button
                size="small"
                color="primary"
                disabled={!props.hasChanges}
                onClick={openChangeLogs}
              >
                View Change Details
              </Button>
              <Button
                disabled={!props.hasChanges}
                variant="contained"
                color="secondary"
                onClick={publishAction}
                endIcon={<PublishIcon />}
              >
                Publish
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
